(function gridDefenition(global) {
  "use strict";

  var ASTERISK = '&#42';

  /**
  * Таблица.
  *
  * @class WebAccess.components.dataViews.Grid
  * @extends BaseObject
  * @mixes WebAccess.mixins.pluginMixin
  * @since 5.2.0.1100
  * @param {string} containerSelector Селектор блока, содержащего таблицу
  * @param {WebAccess.components.dataViews.DataProvider} dataSource Класс, предоставляющий данные для таблицы
  * @param {Array} columns Список колонок таблицы
  * @param {Object} settings Дополнительные параметры
  * @property {dxGrid} dxGrid Ссылка на экземпляр таблицы
  * @property {object} state Объект, хранящий параметры текущей таблицы
  * @property {array} _table Cвязанный объект таблицы клиентской ОМ
  */
  global.components.dataViews.Grid = BaseObject.extend([global.mixins.pluginMixin], {
    _columns: [],
    settings: null,
    state: null,
    containerSelector: null,
    _queryDelay: null,
    _saveStateDelay: null,
    _table: null,

    /**
    * Провайдер данных для таблицы
    * @private
    */
    _dataSource: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (containerSelector, dataSource, columns, settings) {
      var me = this;

      log.info('GRID', 'Grid initialization');
      me.settings = {
        getRowAdditionalInfo: null, /*
          Формат этого свойства:
          function (rowNumber) {
            return {
              cssClasses: '',
              attributes: {}
            }
          }
        */
        cellTemplate: null,
        plugins: null
      };

      if (!dataSource) WA.raise(L('DATA_SOURCE_NOT_SET'));

      me._super(containerSelector, dataSource, columns);
      me._columns = [];

      $.extend(me.settings, settings);
      me.containerSelector = containerSelector;
      me._dataSource = dataSource;


      me._dataSource.loadState().always(function (state) {
        me.state = state || {};
        me._columns = me._initializeColumns(columns);

        //Списка видимых колонок может не быть в состоянии (профиле), поэтому означим их по данным колонок.
        if (!me.state.VisibleColumns || me.state.VisibleColumns.length == 0) {
          me.updateState({
            VisibleColumns: _(me.getVisibleColumns()).map(function (col) { return col.id; })
          });
        }

        // Событие для возможности модифицировать состоение грида, после его загрузки.
        me.fire(WA.CMP.DV.Grid.EVENT.STATE_LOADED);

        me._initializeGrid(containerSelector);
      })
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Связывает с таблицей API.
    * @method WebAccess.components.dataViews.Grid#setTable
    * @since 5.2.0.1100
    */
    setTable: function (table) {
      this._table = table;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает таблицу, связанную с текущей.
    * @method WebAccess.components.dataViews.Grid#getTable
	* @return {WebAccess.components.dataViews.Grid} Таблица.
    * @since 5.5.0.2703
    */
    getTable: function() {
      return this._table;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает список колонок.
    * @method WebAccess.components.dataViews.Grid#getColumns
    * @since 5.4.0.1021
    * @return {Array} Список колонок.
    */
    getColumns: function () {
      return this._columns;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Изменяет колонки таблицы.
    *
    * @method WebAccess.components.dataViews.Grid#setColumns
    * @param {Array} newColumns Список колонок
    * @since 5.4.0.1021
    * @return {WebAccess.components.dataViews.Grid} Grid Таблица.
    */
    setColumns: function (newColumns) {
      var me = this;
      log.info('GRID', 'Updating columns');

      me._columns = newColumns;

      var nextVisibleColumns = me.getVisibleColumns();
      me.grid.setColumns(nextVisibleColumns);
      me.dataView.setColumns(nextVisibleColumns);

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает список видимых колонок.
    * @method WebAccess.components.dataViews.Grid#getVisibleColumns
    * @since 5.2.0.1100
    * @return {Array} Список видимых колонок.
    */
    getVisibleColumns: function () {
      return _(_(this._columns).filter(function (column) {
        return column.visible;
      })).sortBy(function (column) {
        return column.index;
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Инициализация компоненты грида devExtreme
    * @method WebAccess.components.dataViews.Grid#_initializeGrid
    * @private
    * @since 5.2.0.1100
    * @return {WebAccess.components.dataViews.Grid} Grid
    */
    _initializeGrid: function () {
      var me = this;
      var columnFilters = {};

      var options = {
        //showHeaderRow: true, FIXME: Это не здесь должно задаваться и отсутствеие этого здесь ломает фильтрацию
        headerRowHeight: 36,
        rowHeight: 30,
        explicitInitialization: true,
        syncColumnCellResize: true,
        // enableColumnReorder: false, для отключения перетаскивания колонок в записях справочников, документах и диалогах
        // чтобы не было проблем при показе после скрытия.
        enableColumnReorder: WA.getLocation() === 'referencerecords'
      };

      me.dataView = new Slick.Data.DataView();

      var visColumns = me.getVisibleColumns();
      me.fire(WA.CMP.DV.Grid.EVENT.BEFORE_GRID_INIT, me.containerSelector, me.dataView, visColumns, options);

      // Означиваем метод для получения дополнительной информации о строке.
      if (me.settings.getRowAdditionalInfo) {
        me.dataView['getItemAdditionalMetadata'] = me.settings.getRowAdditionalInfo;
      }
      me.grid = new Slick.Grid(me.containerSelector, me.dataView, visColumns, options);
      me.grid._parent = me;

      me.fire(WA.CMP.DV.Grid.EVENT.GRID_INIT, me.grid);

      me.dataView.onRowCountChanged.subscribe(function (e, args) {
        me.grid.updateRowCount();
        me.grid.render();
      });

      me.dataView.onRowsChanged.subscribe(function (e, args) {
        me.grid.invalidateRows(args.rows);
        me.grid.render();
      });

      //При изменении порядка колонок некоторые колонки могут быть скрыты или добавлены, все происходит в одном месте,
      //поэтому требуется проследить чтобы данные о видимых колонках были актуальны.
      me.grid.onColumnsReordered.subscribe(function (ev, columns) {
        if (columns && columns.VisibleColumns) me.updateState({ VisibleColumns: columns.VisibleColumns }, true);
      });

      me.grid.onViewportChanged.subscribe(function (ev, args) {
        me.fire(WA.CMP.DV.Grid.EVENT.VIEWPORT_CHANGED);
      });

      me.grid.init();
      me.reloadData();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сохраняет параметры таблицы.
    *
	* @method WebAccess.components.dataViews.Grid#updateState
    * @param {object} state Параметры
    * @param {boolean} opt_force Признак принудительного сохранения параметров
    * @since 5.2.0.1100
    * @return {WebAccess.components.dataViews.Grid} Таблица.
    */
    updateState: function (state, opt_force) {
      var me = this;

      log.info('GRID', 'Updating state');

      var prevState = me.state;
      var newState = $.extend({}, me.state, state);

      me.state = newState;

      //TODO Оптимизировать - не для каждого изменения состояния надо его сохранять. Например, при изменении номера страницы не надо.
      if ($.toJSON(newState) !== $.toJSON(prevState) || opt_force === true) {
        clearTimeout(me._saveStateDelay); //для сокращения запросов на сервер ВД.
        me._saveStateDelay = setTimeout(function () {
          me._dataSource.saveState(me.state, opt_force).done(function () {
            log.info('GRID', 'New state saved to userprofile');
          }).fail(function (err) {
            log.error("GRID", "Can't save state: " + err);
          });
        }, 0);

        log.debug('GRID', 'New state is:' + $.toJSON(me.state));
      } else {
        log.debug('GRID', 'State not changed');
      }

      return me;
    },

    /**
    * Загружает и обновляет таблицу с учетом переданных параметров.
    *
    * @param {object} options Параметры запроса
    * @method WebAccess.components.dataViews.Grid#reloadData
    * @since 5.2.0.1100
    * @return {Deferred} Deferred-объект.
    */
    reloadData: function (options) {
      var me = this;
      var result = $.Deferred();
      var jContainer = $(me.containerSelector);
      var fadeSpeed = 'fast';
      log.info('GRID', 'Reloading data');

      WA.CR.spinner && WA.CR.spinner.show();

      options = options || {};

      clearTimeout(me._queryDelay);
      me._queryDelay = setTimeout(function () {
        var fadeTO = setTimeout(function () { jContainer.fadeTo(fadeSpeed, .6); }, 500);

        var loadOptions = $.extend({}, me.state, options);
        me.updateState(loadOptions);

        log.info('GRID', 'Reloading data on timeout');
        me.fire(WA.CMP.DV.Grid.EVENT.BEFORE_DATA_LOADED, loadOptions);
        me._dataSource.load(loadOptions).done(function (data) {

          var pageIndex = data.PageIndex;
          var records = data.Rows;

          // Сохраняем новый номер страницы, т.к. она могла поменятся при переходе на последнюю страницу.
          me.updateState({ PageIndex: pageIndex });//fixme не его логика

          me.fire(WA.CMP.DV.Grid.EVENT.DATA_LOADED, pageIndex, !!records ? records.length : 0, records);

          me.dataView.setItems(records);
          me.grid.invalidate();
          me.dataView.endUpdate();

          me.fire(WA.CMP.DV.Grid.EVENT.AFTER_DATA_LOADED, data);
          result.resolve(data);
        }).always(function () {
          clearTimeout(fadeTO);
          jContainer.fadeTo(fadeSpeed, 1);
          WA.CR.spinner && WA.CR.spinner.hide();
        });

      }, 100);

      return result;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Перевод колонок из формата серверного в формат понятный devExtreme
    * @private
    * @param {array} rawColumns Список колонок
    * @method WebAccess.components.dataViews.Grid#_initializeColumns
    * @since 5.2.0.1100
    * @return {array} Список колонок
    */
    _initializeColumns: function (rawColumns) {
      var me = this;
      var ALIGNMENT_RIGHT = 1;

      var columns = _(rawColumns).map(function (column) {
        var isSpecialColumn = (column.Name.charAt(0) === '_');

        var isRequired = column.IsRequired === true || column.IsRequired === 'True';

        var cssClass = (isSpecialColumn ? 'centered' : '');
        if (column.TextAlign == ALIGNMENT_RIGHT) cssClass += ' text_align_right';

        if (column.IsReadOnly) cssClass += ' readonly';

        var columnSettings = {
          name: (isRequired ? ASTERISK : '') + column.Caption,
          id: column.Name,
          field: column.Field,
          cssClass: cssClass,
          sortable: false,
          visible: column.IsVisible === true || column.IsVisible === 'True',
          resizable: false,
          width: +column.Width,
          index: column.Index,
          hint: column.Hint,
          type: column.Type,
          dateType: column.DateType,
          isRequired: isRequired,
          hasCalculation: column.HasCalculation === true || column.HasCalculation === 'True',
          isReadOnly: column.IsReadOnly === true || column.IsReadOnly === 'True',
          requisite: column.Requisite,
          precision: column.Precision
        };


        if (column.Type == REQUISITE_TYPE.DATE && WA.ENV.isTouch()) {
          columnSettings['minWidth'] = 90;
        };

        if (me.state.VisibleColumns && !isNaN(me.state.VisibleColumns.indexOf(column.Name)) && WA.getLocation() === 'referencerecords') {
          columnSettings['index'] = me.state.VisibleColumns.indexOf(column.Name);
        }

        // Шаблонизатор значений в ячейках.
        if (me.settings.cellTemplate) {
          columnSettings['formatter'] = me.settings.cellTemplate;
        }

        if (me.settings.asyncPostRender) {
          columnSettings['asyncPostRender'] = me.settings.asyncPostRender
        }

        if (me.settings.editor) {
          columnSettings['editor'] = me.settings.editor
        }

        me.fire(WA.CMP.DV.Grid.EVENT.COLUMN_INIT, columnSettings);
        return columnSettings;
      });

      return columns;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _excludeSpecialColumns: function (columns) {
      return _(columns).filter(function (column) {
        return (column.id != '_ContextMenu'
             && column.id != '_Checkbox'
             && column.id != '_SelectRecord');
      });
    },

    /**
    * Получает список колонок для выбора видимых колонок.
    *
    * @method WebAccess.components.dataViews.Grid#getColumnsForDialog
    * @since 5.2.0.1100
    * @return {array} Список колонок.
    */
    getColumnsForDialog: function () {
      var me = this;
      var columns = me._excludeSpecialColumns(_(this._columns).clone());
      this.fire(WA.CMP.DV.Grid.EVENT.GET_COLUMNS_FOR_DIALOG, columns);
      return columns;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает список видимых колонок для выбора видимых колонок.

    * @method WebAccess.components.dataViews.Grid#getVisibleColumnsForDialog
	* @description В первый раз список получается из данных, которые пришли с сервера.
    * Если пользователь что-то выбирал, выборка колонок
    * делается на основе актуальных измененных данных dx-грида с учетом выбранных в
    * предыдущий раз видимых колонок.
    * @since 5.2.0.1100
    * @return {array} columns Список колонок.
    */
    getVisibleColumnsForDialog: function () {
      var me = this;
      var columns = me._excludeSpecialColumns(this.getVisibleColumns());
      this.fire(WA.CMP.DV.Grid.EVENT.GET_VISIBLE_COLUMNS_FOR_DIALOG, columns);
      return columns;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    setVisibleColumnsFromDialog: function (newColumns) {
      this.fire(WA.CMP.DV.Grid.EVENT.SET_VISIBLE_COLUMNS_FROM_DIALOG, newColumns);
      this.setVisibleColumns(newColumns);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавляет колонки в список видимых.
    *
    * @method WebAccess.components.dataViews.Grid#setVisibleColumns
    * @param {array} newColumns Список видимых колонок
    * @since 5.2.0.1100
    * @return {WebAccess.components.dataViews.Grid} Grid Таблица.
    */
    setVisibleColumns: function (newColumns) {
      var me = this;
      log.info('GRID', 'Updating visible columns');
      this.fire(WA.CMP.DV.Grid.EVENT.SET_VISIBLE_COLUMNS, newColumns);

      newColumns = me._excludeSpecialColumns(newColumns);
      var visibleIds = _(newColumns).map(function (c) { return c.id });

      me._columns = _(me._columns).map(function (column) {
        var isSpecialColumn = (column.id.charAt(0) === '_');
        var index = visibleIds.indexOf(column.id);
        if (index !== -1 || isSpecialColumn) {
          column.visible = true;
          column.index = index;
        } else {
          column.visible = false;
          if (WA.getLocation() === 'referencerecords') {
            column.index = 0;
          }
        }
        return column;
      });

      var visibleColumns = me.getVisibleColumns();
      for (let column of visibleColumns) {
        column.width = this.state.ColumnsWidth[ column.id ];
      }
      me.dataView.setColumns(visibleColumns);
      me.grid.setColumns(visibleColumns);

      // QueryInstanceID берем из текущего состояния грида в случае если справочник открыли как результат сценария (ориентируемся на параметр uid в урле).
      me.reloadData({
        VisibleColumns: _(visibleColumns).pluck('id') || [],
        QueryInstanceID: ((new WA.URL).getParam('uid')) ? this.state.QueryInstanceID : generateUniqueID()
      });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрытие колонки при добавление группировки по ней
    * @private
    * @method WebAccess.components.dataViews.Grid#hideColumn
    */
    hideColumn: function (id) {
      log.debug('GRID', 'Hiding columns ' + id);
      var me = this;
      var columns = me.getVisibleColumns();
      var newColumns = _(columns).filter(function (col) {
        return id !== col.id;
      });

      me.setVisibleColumns(newColumns);
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показ колонки при удалении группировки по ней
    * @private
    * @method WebAccess.components.dataViews.Grid#showColumn
    */
    showColumn: function (id, opt_index) {
      log.debug('GRID', 'Showing column ' + id);
      log.debug('GRID', 'Showing column index' + opt_index);
      var me = this;
      var columns = me._columns;
      var oldColumns = me.getVisibleColumns();

      var newColumn = _(me._columns).find(function (col) {
        return id == col.id;
      });

      if (newColumn) {
        oldColumns.splice(opt_index || 0, 0, newColumn);
        me.setVisibleColumns(oldColumns);//здесь порядок имеет значение из него строятся индексы
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @function isCurrentPeriodEnabled - функция получает текущее состояние фильтра по периоду.
    * @returns {boolean} - true - если фильтр по периоду включен, false - если фильтр по периоду отключен.
    */
    isCurrentPeriodEnabled: function () {
      return (typeof WA.CR.toolBar.buttons.ToggleCurrentPeriod === 'object' && WA.CR.toolBar.buttons.ToggleCurrentPeriod.isSelected());
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  }, {
    EVENT: {
      /**
      * Срабатывает после вызова конструктора.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.CLASS_INIT
      * @param {object} context ссылка на экземпляр класса
      */
      CLASS_INIT: 'classInit',

      /**
      * Срабатывает до инициализации таблицы.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.BEFORE_GRID_INIT
      * @param {string} containerSelector Селектор основного контейнера
      * @param {object} dataView Класс представления
      * @param {array} visibleColumns Список видимых колонок
      * @param {object} options Параметры таблицы
      */
      BEFORE_GRID_INIT: 'gridBeforeInit',

      /**
      * Срабатывает после запуска конструктора.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.GRID_INIT
      * @param {object} context ссылка на экземпляр класса
      */
      GRID_INIT: 'gridInit',

      /**
      * Срабатывает после инициализации таблицы перед загрузкой данных.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.BEFORE_DATA_LOADED
      * @param {object} state Параметры запроса
      */
      BEFORE_DATA_LOADED: 'beforeDataLoaded',

      /**
      * Срабатывает после загрузки данных.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.DATA_LOADED
      * @param {integer} pageIndex Номер страницы
      * @param {integer} count Количество записей таблицы
      * @param {array} records Полученные записи таблицы
      */
      DATA_LOADED: 'dataLoaded',

      /**
      * Срабатывает после загрузки данных и отображения их в таблице.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.AFTER_DATA_LOADED
      * @param {object} data Полученные данные
      */
      AFTER_DATA_LOADED: 'afterDataLoaded',

      /**
      * Срабатывает перед получением списка доступных колонок.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.GET_COLUMNS_FOR_DIALOG
      * @param {array} columns Список колонок
      */
      GET_COLUMNS_FOR_DIALOG: 'getColumnsForDialog',

      /**
      * Срабатывает перед получением списка видимых колонок.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.GET_VISIBLE_COLUMNS_FOR_DIALOG
      * @param {array} columns Список колонок
      */
      GET_VISIBLE_COLUMNS_FOR_DIALOG: 'getVisibleColumnsForDialog',

      /**
      * Срабатывает перед добавлением колонок в список видимых.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.GET_VISIBLE_COLUMNS_FOR_DIALOG
      * @param {array} columns Список колонок
      */
      SET_VISIBLE_COLUMNS: 'setVisibleColumns',

      /**
      * Срабатывает перед добавлением колонок в список видимых.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.GET_VISIBLE_COLUMNS_FOR_DIALOG
      * @param {array} columns Список колонок
      */
      SET_VISIBLE_COLUMNS_FROM_DIALOG: 'setVisibleColumnsFromDialog',

      /**
      * Срабатывает при переходе на страницу.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.PAGE_CHANGE
      * @param {integer} index Номер страницы
      */
      PAGE_CHANGE: 'pageChange',

      /**
      * Срабатывает при смене количества записей на странице.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.PAGE_CHANGE
      * @param {integer} limit Ограничение количества записей
      */
      PAGE_LIMIT_CHANGE: 'pageLimitChange',

      /**
      * Срабатывает при выделении записей.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.SELECTED_ROWS_CHANGED
      * @param {integer} limit Ограничение количества записей
      */
      SELECTED_ROWS_CHANGED: 'selectedRowsChanged',

      /**
      * Срабатывает при инициализации колонки.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.COLUMN_INIT
      * @param {object} column Колонка
      */
      COLUMN_INIT: 'columnInit',

      /**
      * Срабатывает после загрузки параметров таблицы.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.STATE_LOADED
      */
      STATE_LOADED: 'stateLoaded',

      /**
      * Срабатывает при смене отображаемых значений на экране.
      *
      * @event WebAccess.components.dataViews.Grid.EVENT.VIEWPORT_CHANGED      
      */
      VIEWPORT_CHANGED: 'viewportChanged'
    }
  });

})(window.WA);
